import style from "../../../../assets/scss/common/modal/addChildModal.module.scss";
import React from "react";
import {InitialProfileInfoDTO, ProfileErrorDTO} from "../../../../types/user";
import useValidation from "../../../../hooks/useValidation";
import {useTranslation} from "react-i18next";

interface Args{
    profileInfo: InitialProfileInfoDTO;
    setProfileInfo: React.Dispatch<React.SetStateAction<InitialProfileInfoDTO>>;
    errors: ProfileErrorDTO;
    setErrors: React.Dispatch<React.SetStateAction<ProfileErrorDTO>>;
}
export function ChildGenderField(
    {profileInfo, setProfileInfo, errors, setErrors}:Args)
{
    const { t } = useTranslation("profileInfo");
    const {validateGender} = useValidation();

    const handleGenderSelection = (gender: string) => {
        setProfileInfo((prev: InitialProfileInfoDTO) => ({ ...prev, gender }));
        setErrors((prev: ProfileErrorDTO) => ({
            ...prev,
            gender: validateGender(gender),
        }));
    };

    return (
        <div className={style.infoContainer}>
              <span className={style.infoText}>
                <span className={style.requireText}>
                    {t('profileInfo.addModal.required')}
                </span> {t('profileInfo.addModal.gender.label')}
              </span>
            <div className={style.genderButtons}>
                <button
                    className={`${style.genderBtn} ${profileInfo.gender === "MALE" ? style.selectedGender : ""}`}
                    onClick={() => handleGenderSelection("MALE")}
                >{t('profileInfo.addModal.gender.male')}
                </button>
                <button
                    className={`${style.genderBtn} ${profileInfo.gender === "FEMALE" ? style.selectedGender : ""}`}
                    onClick={() => handleGenderSelection("FEMALE")}
                >{t('profileInfo.addModal.gender.female')}
                </button>
            </div>
            {errors.gender && <div className={style.errorText}>{errors.gender}</div>}
        </div>
    )
}